import {AutoMap} from '@automapper/classes';

export class TBaseGetAllRequestDto {
}

export class TBaseGetRequestDto {
  @AutoMap()
  id!: string;
}

export class TBaseLookupRequestDto {
  @AutoMap()
  query!: string;
}

export class TBaseCreateRequestDto {
}

export class TBaseUpdateRequestDto {
  @AutoMap()
  id!: string;
}

export class TBaseDeleteRequestDto {
  @AutoMap()
  id!: string;
}

export class TBaseBulkDeleteRequestDto {
  @AutoMap()
  ids!: string[];
}
